import {
  CustomFilterUnion,
  CustomFilterConfig,
  CFChangeEvent,
  CustomFilterSettings,
  CFInputItemSetting,
  CFDateItemSetting,
  CFSelectItemSetting,
  CFCheckBoxItemSetting,
  TCustomFilter,
} from "./types";
import { DateFilterEvent, DateFilterSetting } from "../date/types";
import DateFilter from "../date/DateFilter";
import CustomFilterInputItem from "./CustomFilterInputItem";
import CustomFilterDateItem from "./CustomFilterDateItem";
import CustomFilterSelectItem from "./CustomFilterSelectItem";
import CustomFilterCheckBoxItem from "./CustomFilterCheckBoxItem";
import CustomFilterSubItem from "./CustomFilterSubItem";
import Button from "@/components/bricks/button/Button";
import CloseSmallIcon from "../../icons/CloseSmallIcon";

export default function CustomFilterItem<C extends CustomFilterUnion>(props: {
  filterConfig: CustomFilterConfig<C> | undefined;
  onChangeFilter: (event: CFChangeEvent) => void;
  onRemoveFilter: () => void;
  settings: CustomFilterSettings | undefined;
}) {
  // destruction
  const { filterConfig, onChangeFilter, onRemoveFilter, settings } = props;

  // filter event handlers
  function inputEventHandler(event: CFChangeEvent) {
    onChangeFilter(event);
  }

  function dateEventHandler(event: CFChangeEvent) {
    onChangeFilter(event);
  }

  function selectEventHandler(event: CFChangeEvent) {
    onChangeFilter(event);
  }

  function checkEventHandler(event: CFChangeEvent) {
    onChangeFilter(event);
  }

  function datePeriodEventHandler(dateFilterEvent: DateFilterEvent) {
    if (dateFilterEvent.filter && dateFilterEvent.settings) {
      const event: CFChangeEvent = {
        filterString: "none",
        filterObj: { periode: dateFilterEvent.filter },
        filterSettings: dateFilterEvent.settings,
      };
      onChangeFilter(event);
    }
  }

  return (
    <div className="c-custom-filter__item">
      <div className="c-custom-filter__header">
        <h3>{filterConfig?.displayName}</h3>
        <Button
          transparent
          color="secondary"
          aria-label="Fjern filter"
          className="btn--icon btn--sm"
          onClick={onRemoveFilter}
        >
          <CloseSmallIcon width={17} />
        </Button>
      </div>

      {(() => {
        switch (filterConfig?.component.type) {
          case "input":
            return (
              <CustomFilterInputItem
                config={filterConfig}
                filterEvent={(event) => {
                  inputEventHandler(event);
                }}
                settings={settings as CFInputItemSetting[]}
              />
            );
          case "date":
            return (
              <CustomFilterDateItem
                config={filterConfig}
                filterEvent={(event) => {
                  dateEventHandler(event);
                }}
                settings={settings as CFDateItemSetting[]}
              />
            );
          case "select":
            return (
              <CustomFilterSelectItem
                config={filterConfig}
                filterEvent={(event) => {
                  selectEventHandler(event);
                }}
                settings={settings as CFSelectItemSetting}
              />
            );
          case "period":
            return (
              <div className="c-custom-filter__content">
                <DateFilter
                  handleChange={(dateFilterEvent: DateFilterEvent) => {
                    datePeriodEventHandler(dateFilterEvent);
                  }}
                  settings={settings as DateFilterSetting}
                />
              </div>
            );
          case "checkbox":
            return (
              <CustomFilterCheckBoxItem
                config={filterConfig}
                filterEvent={(event) => {
                  checkEventHandler(event);
                }}
                settings={settings as [CFCheckBoxItemSetting]}
              />
            );
          case "nested":
            return (
              <CustomFilterSubItem
                filterConfig={filterConfig}
                onChangeFilter={onChangeFilter}
                settings={settings as TCustomFilter[]}
              />
            );
        }
      })()}
    </div>
  );
}
